import { FC } from 'react';
import { NewsIframeProps } from './types';

export const NewsIframe: FC<NewsIframeProps> = ({
  episode,
  width = '100%',
}) => {
  return (
    <>
      <iframe
        src={episode}
        width={width}
        height={152}
        title="spotify-iframe"
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture;"
        sandbox="allow-scripts allow-same-origin"
        loading="lazy"
        seamless
        style={{
          border: 0,
          borderRadius: 12,
          marginBottom: 8,
        }}
      />
    </>
  );
};
